import {
	Autoplay,
	Navigation,
	Swiper
} from 'swiper';

import {
	$Elements,
	BrowserEvents,
	Classes,
	TransitionDurations
} from './constants';
import {
	initGTM,
	setCookiesAllowed,
	setDisclaimerAccepted
} from './helpers';

Swiper.use([Autoplay, Navigation]);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Disclaimer ----------

		$('#disclaimer').each(function() {

			$Elements.body.addClass('disclaimer-open');

			$(this).on('closed.bs.alert', function() {

				setDisclaimerAccepted();
				$Elements.body.removeClass('disclaimer-open');

				const dataInformations = $('#informations').data('informations');

				if(!dataInformations || dataInformations === undefined) {
					$(this).addClass(Classes.hidden);
					$Elements.body.removeClass('disclaimer-open');
					$Elements.HeaderWrapper.addClass(Classes.active);
					$('.hero-section').addClass(Classes.active);
				}
				else {
					initInformationModal();
				}
			});
		});

		if($('#disclaimer').length < 1) {
			initInformationModal();
		}

		// ---------- Informations ----------

		function initInformationModal() {
			$('#informations').each(function() {
				const dataInformations = $(this).data('informations');

				if(dataInformations) {
					$(this).removeClass(Classes.invisible)
					$Elements.body.addClass('disclaimer-open');

					$(this).on('closed.bs.alert', function() {
						$(this).addClass(Classes.hidden);
						$Elements.body.removeClass('disclaimer-open');
						$Elements.HeaderWrapper.addClass(Classes.active);
						$('.hero-section').addClass(Classes.active);

					});
				}
			});
		}

		// ---------- Cookies ----------

		initGTM();

		$('#cookies-law').on('click', '.btn', function() {
			setCookiesAllowed(this.dataset.allowed);
		});

		// ---------- Masonry ----------

		$('.content-section .section-masonry').each(function() {
			const self = $(this);

			self.isotope({
				masonry:      {
					percentPosition: true
				},
				itemSelector: ".single-column"
			})
		});

		// ---------- Carousel ----------

		$('.content-section .section-carousel, .content-section .column-carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed:      TransitionDurations.default,
					loop:       true,
					observer:   true,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		// ---------- Slideshow ----------

		$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed:      TransitionDurations.default,
					loop:       true,
					observer:   true,
					autoplay:   true,
					effect:     'fade',
					pagination: {
						el: this.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

	});

}(jQuery));
